import { createElement, useState } from 'react';
import { Drawer, Button, Search, Tree, Icon } from '@alifd/next';
import cls from 'classnames/bind';
import style from './index.module.scss';
const cx = cls.bind(style);
const DrawPicker = (props) => {
    const { value, onChange, title, options } = props;
    const [visible, setVisble] = useState(false);
    const [ops, setOps] = useState(options || []);
    const [val, setVal] = useState(value || []);
    const openDrawer = () => {
        setVisble(true);
        setVal(value || []);
    };
    const closeDrawer = () => {
        setVisble(false);
    };
    const resetCheck = () => {
        setVal([]);
    };
    const submitCheck = () => {
        onChange(val);
        closeDrawer();
    };
    const CheckboxChange = (value) => {
        setVal(value);
    };
    const pikeAll = () => {
        setVal(options.map((e) => e?.key));
    };
    const pikeReverse = () => {
        setVal(options.filter((e) => !val.includes(`${e?.key}`)).map((e) => e?.key));
    };
    const mysearch = (text) => {
        setOps(options.filter((e) => e.label.includes(text)));
    };
    return (createElement("div", null,
        createElement("div", { onClick: openDrawer, className: cx('drawerTriger') },
            title,
            createElement(Icon, { size: "xs", type: "toggle-left" })),
        createElement(Drawer, { title: title, width: "60vw", placement: "right", visible: visible, onClose: closeDrawer },
            createElement("div", { className: cx('drawer') },
                createElement("div", null,
                    createElement("div", { className: cx('pikerCtrl') },
                        createElement(Button, { onClick: pikeAll, type: "primary" }, "\u5168\u9009"),
                        createElement(Button, { onClick: pikeReverse, type: "normal" }, "\u53CD\u9009")),
                    createElement(Search, { shape: "simple", size: "medium", onSearch: mysearch, style: { width: '100%', marginBottom: '5px' } }),
                    createElement("div", { className: cx('main') },
                        createElement(Tree, { checkedKeys: val, autoExpandParent: false, checkable: true, checkedStrategy: "parent", dataSource: ops, onCheck: CheckboxChange }))),
                createElement("div", { className: cx('footer') },
                    createElement("div", { className: cx('btns') },
                        createElement(Button, { onClick: resetCheck, type: "secondary" }, "\u91CD\u7F6E"),
                        createElement(Button, { onClick: submitCheck, type: "primary" }, "\u786E\u5B9A")))))));
};
export default DrawPicker;
